<template>
  <section class="product-presentation section" :class="[{'theme-vespa': isThemeVespa}, showHero ? 'has-hero' : '', this.common.productPresentationConf[this.model.productType].designVariant]">
    <pg-breadcrumb
        :class="breadcrumbClasses"
        :link="model.breadcrumb.link"
        :label="model.breadcrumb.label"
        v-if="!common.iframe && model.breadcrumb"
        :icon="false"
    ></pg-breadcrumb>
    <div class="hero" v-if="showHero">
      <picture>
        <source
            media="(min-width:0) and (max-width:1023px)"
            :srcset="model.heroImageMobile | mgnlMedia('url')"
            v-if="model.heroImageMobile"
        />
        <source
            media="(min-width:1024px)"
            :srcset="model.heroMedia | mgnlMedia('url')"
            v-if="model.heroMedia"
        />
        <pg-image
            :lazy-src="model.heroImageMobile | mgnlMedia('url')"
            v-if="model.heroImageMobile"
        ></pg-image>
        <pg-image
            :lazy-src="model.heroMedia | mgnlMedia('url')"
            v-else
        ></pg-image>
      </picture>
    </div>
    <div :class="classes" :style="{ minHeight: minHeight+'px' }">
      <div>

        <h1 class="product-presentation__title" :class="showHero ? 'is-white' : ''">{{model.name}}</h1>
        <template v-if="showCode">
          <p class="product-presentation__code" v-if="currentDataSize">
            {{currentDataSize.compositeSapCode}}
          </p>
          <p class="product-presentation__code" v-else>
            {{currentDataProduct.compositeSapCode}}
          </p>
        </template>

        <p
            class="product-presentation__abstract product-presentation__abstract--large"
            v-if="model.abstract"
        >{{model.abstract}}</p>

        <div v-if="currentDataProduct.sizes" class="product-presentation_colors__size">
          <p class="product-presentation_colors__size__title">
            <msg id="common.product-presentation.sizes.text"/>
          </p>
          <ol class="product-presentation_colors__size__list">
            <li v-for="(size,index) in currentDataProduct.sizes" :key="size.compositeSapCode">
              <pg-button
                  class="button--size"
                  :class="isSizeActive(index)"
                  :eventParams="{ index }"
                  eventName="productPresentation:selectSize"
              >{{size.name}}
              </pg-button>
            </li>
          </ol>
        </div>

        <div class="product-presentation_colors">
          <span class="product-presentation_colors__current-color" v-if="showColors">
            <template v-if="isThemeVespa"><msg id="common.product-presentation.color" />: </template>{{currentDataProduct.label ? currentDataProduct.label.toLowerCase() : currentDataProduct.label}}
          </span>

          <b-tabs
              content-class="product-presentation__colors__images"
              nav-wrapper-class="product-presentation_colors__swatches"
              v-model="currentTab"
              @input="updateCarousel"
              end
         >
            <b-tab
                    v-for="(color, colorIndex) in orderedColoredProducts"
                    :key="colorIndex"
                    :active="isActive(colorIndex)"
                    @click="() => {
                      selections.color = {
                        code: color.code,
                        label: color.label
                      }
                    }"
            >
              <template v-slot:title>
                <pg-swatch :color="color" class="swatches-color--xl" v-if="showColors" />
              </template>
              <div class="carousel">
                <div class="carousel__arrows" v-if="color.images.length > 1">
                  <pg-button
                      class="carousel__arrows__prev"
                      :styleType="'icon'"
                      :icon="'icon-arrow-sx'"
                      :eventParams="{}"
                      :eventName="`carouselV2:Prev`"
                  >
                    <msg id="common.carousel.previous.aria"/>
                  </pg-button>
                  <pg-button
                      class="carousel__arrows__next"
                      :styleType="'icon'"
                      :icon="'icon-arrow-dx'"
                      :eventParams="{}"
                      :eventName="`carouselV2:Next`"
                  >
                    <msg id="common.carousel.next.aria"/>
                  </pg-button>
                </div>
                <hooper v-if="color.images.length > 0" :ref="`carousel-${colorIndex}`" :settings="hooperSettings" :touch-drag="color.images.length > 1">
                  <hooper-slide
                      v-for="(image, imageIndex) in color.images"
                      :key="imageIndex"
                      :index="imageIndex"
                  >
                    <div v-if="isThemeVespa" class="hooper-overlay" :style="`background-color: ${color.code};`"></div>
                    <pg-image
                        :lazy-src="image.small"
                        :lazy-srcset="imageSrcset(image)"
                        :sizes="imageSizes"
                        :productType="model.productType"
                        :brandCode="common.brandCode"
                        :alt="color.alt"
                        eventName="productPresentation:imageLoaded"
                    ></pg-image>
                  </hooper-slide>
                </hooper>
                <pg-image
                    v-else
                    :lazy-src="null"
                    :sizes="imageSizes"
                    :productType="model.productType"
                    :brand-code="common.brandCode"
                ></pg-image>
              </div>
            </b-tab>
          </b-tabs>
        </div>

        <div class="product-presentation__price product-price" aria-live="polite"
             v-if="showProductPrice || showPlannedPrice">

          <!-- PREZZO PROMOZIONALE: Per essere visibile la promo deve essere visibile necessariamente anche il prezzo base -->
          <span class="product-price__discounted" v-if="showProductPrice && showPromoPrice">
            {{ currentDataProduct.discountedPrice | formatPrice(common.priceFormatting )}}
            <pg-tooltip v-if="common.priceNote" :class="tooltipPriceClasses">
              <msg id="common.price.tooltip.text"/>
            </pg-tooltip>
          </span>


          <!-- PREZZO PRODOTTO -->
          <span class="product-price__list" v-if="showProductPrice">
            <span>{{ currentDataProduct.price | formatPrice(common.priceFormatting) }}</span>
            <pg-tooltip v-if="common.priceNote && !showPromoPrice" :class="tooltipPriceClasses">
              <msg id="common.price.tooltip.text"/>
            </pg-tooltip>
          </span>

          <!-- PREZZO RATA -->
          <span class="product-price__planned" v-if="showPlannedPrice">
            <msg id="common.product-presentation.starting-from.text"
                 :params="[{ key: 'price', value: $options.filters.formatPrice(currentDataProduct.plannedPrice, common.priceFormatting) }]" :bare="true"/>
          </span>

        </div>

        <p class="product-presentation__abstract product-presentation__abstract--small" v-if="model.abstract">
          {{model.abstract}}</p>



        <div class="product-presentation__ctas call-to-action" v-if="isSantanderSimulatorEnabled(common.santanderFinancialSimulator)">
          <button
              @click="openSantanderFinancialSimulator()"
              type="button"
              :class="[ 'button', 'button--contained', 'button--medium', 'button--primary' ]">
            <msg id="common.product-presentation.financial-simulator-cta.text"/>
          </button>
        </div>
      </div>
    </div>
    <script v-html="jsonld" type="application/ld+json"></script>
    <script type="application/javascript" :src="getSantanderScriptSrc" v-if="isSantanderSimulatorEnabled(common.santanderFinancialSimulator)"></script>
  </section>
</template>

<script>
  import {mgnlComponentMixin} from "@wl-vue-mixins/mixins.js";
  import {
    Hooper,
    Slide as HooperSlide,
    Navigation as HooperNavigation
  } from "hooper";

  import PgBreadcrumb from "../Breadcrumb/Breadcrumb.vue";
  import PgImage from "../Image/Image.vue";
  import PgSwatch from "../Swatch/Swatch.vue";
  import PgButton from "../Button/Button.vue";
  import PgTooltip from "../Tooltip/Tooltip.vue";
  import {arrayMove, arraySortBy} from "../../utils/common-utils";

  export default {
    mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
    name: "product-presentation",
    components: {
      Hooper,
      HooperNavigation,
      HooperSlide,
      PgBreadcrumb,
      PgButton,
      PgImage,
      PgSwatch,
      PgTooltip
    },
    data() {
      return {
        hooperSettings: {
          initialSlide: 0,
          itemsToShow: 1,
          itemsToSlide: 1,
          centerMode: false,
          wheelControl: false,
          infiniteScroll: true,
          mouseDrag: false
        },
        currentTab: 0,
        minHeight: 540,
        selectedSizeIndex: 0,
        selections: {
          color: {
            code: '',
            label: ''
          }
        }
      };
    },

    computed: {
      getSantanderScriptSrc() {
        return `${this.$config.santanderSimFinEndpoint}?pluginId=${this.common?.santanderFinancialSimulator?.santanderPluginId}`;
      },
      orderedColoredProducts() {
        // ordering colors by colorHex and putting default color as first
        const colors = (this.model.colors || []);
        let orderedByHex = arraySortBy(colors, "code", "desc");
        const currentPos = orderedByHex.findIndex((element) => element.defaultColor);
        console.log(colors);
        console.log(currentPos);

        if (currentPos > 0) {
          orderedByHex = arrayMove(orderedByHex, currentPos, 0);
        }

        return orderedByHex;
      },
      getProductConfiguration() {
        return this.common && this.common.productPresentationConf && this.common.productPresentationConf.hasOwnProperty(this.model.productType) ?
          this.common.productPresentationConf[this.model.productType] : {};
      },
      showProductPrice() {
        return this.getProductConfiguration.showPricePP && this.currentDataProduct.price;
      },
      showPromoPrice() {
        return this.getProductConfiguration.showPromoPP && this.currentDataProduct.discountedPrice;
      },
      showPlannedPrice() {
        return this.getProductConfiguration.showPlannedPP && this.currentDataProduct.plannedPrice;
      },
      showCode() {
        return (this.getProductConfiguration.showCodePP && this.currentDataProduct.compositeSapCode) || this.model.productType === "vehicle";
      },
      showColors() {
        return this.getProductConfiguration.showColorsPP || this.model.productType === "vehicle";
      },
      classes() {
        let classList;
        if (this.model.productType == "vehicle") {
          classList = [
            "section__container",
            "product-presentation__container",
            "product-presentation--" +
            this.common.productPresentationConf[this.model.productType]
              .designVariant
          ];
        } else {
          classList = [
            "section__container",
            "product-presentation__container",
            "product-presentation--horizontal"
          ];
        }
        return classList;
      },
      breadcrumbClasses() {
        let color = this.showHero ? " button--white" : "button--black";
        return [color];
      },
      tooltipPriceClasses() {
        return document.body.classList.contains('theme-vespa') ? "product-price__tooltip-vespa" : "product-presentation-price__tooltip"
      },
      breadcrumbIcon() {
        let hasIcon =
          (this.common.productPresentationConf[this.model.productType] &&
            this.common.productPresentationConf[this.model.productType]
              .designVariant === "horizontal") ||
          this.model.productType === "accessory";
        return hasIcon;
      },
      imageSizes() {
        return `(max-width: 640px) 80vw, (max-width: 1024px) 50vw, 50vw`;
      },
      isPromo() {
        // chiamata PQM
        return true;
      },
      currentDataProduct() {
        return this.orderedColoredProducts[this.currentTab];
      },
      currentDataSize() {
        return this.model.colors[this.currentTab].sizes
          ? this.model.colors[this.currentTab].sizes[this.selectedSizeIndex]
          : false;
      },
      showHero() {
        //TODO capire come gestire il get di una proprietà sull'undefined in edit mode (HELP ANDREA GALBIATI!!!)
        if (!this.common.productPresentationConf || !this.model.productType) {
          return false;
        }

        let condition =
          this.common.productPresentationConf[this.model.productType] &&
          this.common.productPresentationConf[this.model.productType]
            .designVariant === "vertical" &&
          ((this.model.heroMedia && this.model.heroMedia.type === "image") ||
            (this.model.heroImageMobile &&
              this.model.heroImageMobile.type === "image"));

        return condition;
      },
      jsonld() {
        return {
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": this.model.name?.trim(),
          "image": this.currentDataProduct.images[0]?.small,
          "description": this.model.autoMetaDescription,
          "brand": {
            "@type": "Brand",
            "name": this.$options.filters.capitalize(this.common.brandName)
          },
          "offers": {
            "@type": "Offer",
            "url": this.common.actpageFullUrl,
            "priceCurrency": this.common.priceFormatting.priceCurrencyCode,
            "price": this.currentDataProduct.price,
          }
        }
      },
      isThemeVespa() {
        // Check if the body contains the class "theme-vespa"
        if (typeof document !== 'undefined') {
          return document.body.classList.contains("theme-vespa");
        } else {
          return false
        }
      }
    },

    mounted() {
      this.$eventHub.emit('currentDataProduct', this.currentDataProduct);
      this.$eventHub.on(
        "productPresentation:selectSize",
        ({index}) => (this.selectedSizeIndex = index)
      );

      this.$eventHub.on("productPresentation:imageLoaded", eventParams => {
        //console.log("recalculating min height", eventParams.clientHeight + 15);
        this.minHeight = eventParams.clientHeight + 15;
      });

      //console.log()

      this.$eventHub.on(`carouselV2:Prev`, () => {
        this.slidePrev();
      });
      this.$eventHub.on(`carouselV2:Next`, () => {
        this.slideNext();
      });

      const defaultColor = this.model.colors.find(c => c.defaultColor)
      if (defaultColor) {
        this.selections.color = {
          label: defaultColor.label,
          code: defaultColor.code
        }
      }
    },

    methods: {
      colorToShow(items) {
        return items.slice(0, 1);
      },
      isActive(index) {
        return index === 0;
      },
      isDisabled(images) {
        return !(images && images.length > 0);
      },
      carouselClasses(index) {
        return ["carousel__item", index === 0 ? "is-visible" : ""];
      },
      buttonClasses(index) {
        return index === 0 ? "contained" : "text";
      },
      hasImages(images) {
        return images && images.length > 0;
      },
      hasCtas(ctas) {
        return ctas && ctas.length > 0;
      },
      isSizeActive(index) {
        if (index === this.selectedSizeIndex) {
          return "active";
        }
      },

      imageSrcset(image) {
        return image.small && image.medium && image.large
          ? `${image.small} 750w, ${image.medium} 1368w, ${image.large} 3000w`
          : ""; // temporary hardcoded images width
      },

      updateCarousel() {
        let currentCarousel = this.$refs[`carousel-${this.currentTab}`][0];

        setTimeout(() => {
          currentCarousel.update();
        }, 10);
      },
      slidePrev() {
        let currentCarousel = this.$refs[`carousel-${this.currentTab}`][0];

        setTimeout(() => {
          currentCarousel.slidePrev();
        }, 10);
      },
      slideNext() {
        let currentCarousel = this.$refs[`carousel-${this.currentTab}`][0];

        setTimeout(() => {
          currentCarousel.slideNext();
        }, 10);
      },
      analyticsData(el) {
        return {
          evCategory: 'call_to_action',
          evAction: el.document?.url || el.link?.url || el.trackingLabel,
          evLabel: `${el.campaignId || 'No Campaign'} | ${this.common.actpageFullUrl}`
        }
      },
      openSantanderFinancialSimulator() {
        this.$eventHub.emit('currentDataProduct', this.currentDataProduct);
        this.$analytics.pushEvent('financial_simulator', 'open_simulator', 'open_simulator');
        return scfSimulation.openSimulator();
      },
      isSantanderSimulatorEnabled(santanderFinSim) {
        return santanderFinSim &&
            santanderFinSim.santanderEnabledForBrand &&
            santanderFinSim.santanderEnabledForCountry &&
            santanderFinSim.santanderPluginId &&
            this.currentDataProduct.financingCode;
      },

    }
  };
</script>